export default function Menu() {
  return {}
}
